import { createSlice, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import {IIndexable} from "../../../domain/interfaces";
import {getJSONFromHtml} from "../../../domain/common";
import {PersonalDealDM} from "../interfaces";


export interface StateInterface extends IIndexable{
    dailyDeals: PersonalDealDM[];
    imgCMSDomain:string
}
// initial state
const initialState: StateInterface = {
    dailyDeals: getJSONFromHtml(document.getElementById('daily-deals-data')) as PersonalDealDM[],
    imgCMSDomain:(document.getElementById('img-cdn-domain')?.textContent || '')?.trim().toLowerCase()
}
// the main slice
const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {
        main(state, action) {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

const store = configureStore({
    reducer: rootSlice.reducer,
});

export const rootActions = rootSlice.actions;
export default store;

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 * https://redux.js.org/recipes/usage-with-typescript
 */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux.js.org/recipes/usage-with-typescript
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

